import { Component, input } from '@angular/core';

@Component({
  selector: 'app-pb-dashboard-frame',
  standalone: true,
  imports: [],
  templateUrl: './pb-dashboard-frame.component.html',
  styleUrl: './pb-dashboard-frame.component.scss'
})
export class PbDashboardFrameComponent {

  title = input<string>();
  subtitle = input<string>();
  showHoverOver = input<boolean>(true);
  isLoading = input<boolean>(false);
  loadingMessage = input<string>('Loading...');

  /** When true the frame sizes to its content instead of filling the row */
  fitContent = input<boolean>(false);
    
}
